module.exports = __webpack_public_path__ + "img/chat-dots.7d97145d.svg";